//
//
//
//
//
//
//
//

import Tabbar from '@/components/Tabbar.vue'
import FollwDialog from '@/components/FollwDialog.vue'
export default {
  name: 'App',
  components: {
    Tabbar,
    FollwDialog
  },
  created() {
    this.$store.dispatch('SET_VIP_CONFIG')
    if (process.env.NODE_ENV === 'development') {
      this.login()
    } else {
      this.$store.dispatch('INIT_BASE_DATA')
      console.log(`${this.$ROOTURL}${this.shareConfig.link}`)
      this.$wxSdk.onMenuShare(this.shareConfig.title, this.shareConfig.desc, `${this.$ROOTURL}${this.shareConfig.link}`, this.shareConfig.imgUrl)
    }
  },
  methods: {
    login() {
      this.$http.login({ mobile: '18127953925', code: '1024' }).then(res => {
        this.$store.dispatch('INIT_BASE_DATA')
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue